/* Mimories – correctifs audit (priorités HAUTES) */
(function () {
  var BAD = /\{\{\s*n\s*\}\}/g;
  // Judge.me : supprime le texte brut « {{ n }} » partout où il apparaît
  function fixReviews(root) {
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, { acceptNode: function(node) { return node.parentElement && node.parentElement.closest('.jdgm-widget, .jdgm-prev-badge, .jdgm-rev-widg') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; } });
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeValue.indexOf('{' + '{') !== -1 && BAD.test(n.nodeValue)) {
        BAD.lastIndex = 0;
        n.nodeValue = n.nodeValue.replace(BAD, '').replace(/\s{2,}/g, ' ');
      }
      BAD.lastIndex = 0;
    }
  }
  function start() {
    fixReviews();
    function consentCopy() {
      var p = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
      if (!p || p.dataset.mimCompact) return;
      var policy = p.querySelector('a');
      p.textContent = 'Avec votre accord, nous et nos partenaires, dont Shopify, utilisons des cookies pour personnaliser l’expérience, mesurer l’audience et afficher des publicités. ';
      if (policy) p.appendChild(policy);
      p.dataset.mimCompact = 'true';
    }
    consentCopy();
    new MutationObserver(consentCopy).observe(document.body, {childList:true,subtree:true});
    document.addEventListener('click', function(event) {
      var link = event.target.closest('[data-mim-continue]');
      if (!link) return;
      var drawer = link.closest('cart-drawer-component');
      if (drawer && typeof drawer.close === 'function') { event.preventDefault(); drawer.close(); }
    });
    new MutationObserver(function () { fixReviews(); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  // Confirmation visible à l'ajout au panier
  function toast(msg) {
    var t = document.createElement('div'); t.className = 'mim-toast'; t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 300); }, 2400);
  }
  var f = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return f.apply(this, arguments).then(function (r) {
      if (/\/cart\/add/.test(url) && r.ok) {
        toast('✓ Ajouté au panier');
        document.querySelectorAll('.add-to-cart-button').forEach(function (b) {
          b.classList.add('mim-added'); setTimeout(function () { b.classList.remove('mim-added'); }, 1800);
        });
      }
      return r;
    });
  };
})();

/* Phase 2 : copie du code promo */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-mim-copy]');
  if (!b) return;
  e.preventDefault();
  var code = b.getAttribute('data-mim-copy');
  var hint = b.querySelector('.mim-copy__hint');
  function done() { b.classList.add('is-copied'); if (hint) hint.textContent = 'Copié !'; setTimeout(function () { b.classList.remove('is-copied'); if (hint) hint.textContent = 'Copier'; }, 2000); }
  if (navigator.clipboard && window.isSecureContext) { navigator.clipboard.writeText(code).then(done, done); }
  else { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (err) {} t.remove(); done(); }
});
